"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldHelperMessage = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importDefault(require("react"));

var FieldHelperMessage = function FieldHelperMessage(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      helperMessage = _a.helperMessage,
      id = _a.id,
      isInverse = _a.isInverse;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'FieldHelperMessage',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(ui_text_1.Text, {
    className: rootClasses,
    pattern: "caption",
    element: "div",
    color: isInverse ? 'grey-400' : 'grey-600',
    id: id
  }, helperMessage);
};

var FieldHelperMessageWithSpace = (0, ui_helper_with_space_1.withSpace)(FieldHelperMessage);
exports.FieldHelperMessage = FieldHelperMessageWithSpace;